var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Input, Tag } from "antd";
import { CloseOutlined } from "@ant-design/icons";
var CompsTags = function (_a) {
    var _b = _a.tags, tags = _b === void 0 ? [] : _b, onChange = _a.onChange, onAddTagRequest = _a.onAddTagRequest, onRemoveTagRequest = _a.onRemoveTagRequest, _c = _a.placeholder, placeholder = _c === void 0 ? "输入标签后按回车添加，支持用逗号分隔多个标签" : _c, _d = _a.disabled, disabled = _d === void 0 ? false : _d, maxTags = _a.maxTags, style = _a.style, className = _a.className, _e = _a.hideInput, hideInput = _e === void 0 ? false : _e, _f = _a.draggable, draggable = _f === void 0 ? true : _f;
    // 输入框的值
    var _g = useState(""), inputValue = _g[0], setInputValue = _g[1];
    // 标签列表
    var _h = useState([]), tagList = _h[0], setTagList = _h[1];
    // 当前悬停的标签 key
    var _j = useState(null), hoveredTagKey = _j[0], setHoveredTagKey = _j[1];
    var _k = useState(null), draggingKey = _k[0], setDraggingKey = _k[1];
    // 解析标签数据，支持数组或JSON字符串
    var parseTags = function (tagsData) {
        if (typeof tagsData === "string") {
            try {
                var parsed = JSON.parse(tagsData);
                return Array.isArray(parsed) ? parsed : [];
            }
            catch (_a) {
                return [];
            }
        }
        return Array.isArray(tagsData) ? tagsData : [];
    };
    // 初始化标签列表
    useEffect(function () {
        var parsedTags = parseTags(tags);
        setTagList(parsedTags);
    }, [tags]);
    // 生成标签唯一ID
    var generateTagId = function () {
        return "tag-".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9));
    };
    // 添加标签
    var handleAddTag = function () { return __awaiter(void 0, void 0, Promise, function () {
        var trimmedValue, tagLabels, existingLabels, newLabels, currentTagCount, remainingSlots, labelsToAdd, newTags, updatedTags, allowed, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trimmedValue = inputValue.trim();
                    // 检查输入是否为空
                    if (!trimmedValue) {
                        return [2 /*return*/];
                    }
                    tagLabels = trimmedValue
                        .split(/[,，]/) // 支持英文逗号和中文逗号
                        .map(function (label) { return label.trim(); }) // 去除每个标签的前后空格
                        .filter(function (label) { return label.length > 0; });
                    // 如果没有有效的标签，直接返回
                    if (tagLabels.length === 0) {
                        setInputValue("");
                        return [2 /*return*/];
                    }
                    existingLabels = new Set(tagList.map(function (tag) { return tag.label.toLowerCase(); }));
                    newLabels = tagLabels.filter(function (label) { return !existingLabels.has(label.toLowerCase()); });
                    // 如果没有新标签需要添加，清空输入框后返回
                    if (newLabels.length === 0) {
                        setInputValue("");
                        return [2 /*return*/];
                    }
                    currentTagCount = tagList.length;
                    remainingSlots = maxTags ? maxTags - currentTagCount : Infinity;
                    labelsToAdd = remainingSlots < newLabels.length
                        ? newLabels.slice(0, remainingSlots)
                        : newLabels;
                    newTags = labelsToAdd.map(function (label) { return ({
                        id: generateTagId(),
                        label: label,
                    }); });
                    updatedTags = __spreadArray(__spreadArray([], tagList, true), newTags, true);
                    if (!onAddTagRequest) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onAddTagRequest(newTags, updatedTags)];
                case 2:
                    allowed = _a.sent();
                    // 如果外部拒绝，不更新标签列表，但清空输入框
                    if (!allowed) {
                        setInputValue("");
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    // 如果请求失败，不更新标签列表，但清空输入框
                    setInputValue("");
                    return [2 /*return*/];
                case 4:
                    // 更新标签列表
                    setTagList(updatedTags);
                    // 清空输入框
                    setInputValue("");
                    // 触发变化回调（仅在确认后触发）
                    if (onChange) {
                        onChange(updatedTags);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // 删除标签
    var handleRemoveTag = function (tagToRemove) { return __awaiter(void 0, void 0, Promise, function () {
        var updatedTags, allowed, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    updatedTags = tagList.filter(function (tag) {
                        // 如果有id，使用id比较，否则使用label比较
                        if (tagToRemove.id !== undefined && tag.id !== undefined) {
                            return tag.id !== tagToRemove.id;
                        }
                        return tag.label !== tagToRemove.label;
                    });
                    if (!onRemoveTagRequest) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, onRemoveTagRequest(tagToRemove, updatedTags)];
                case 2:
                    allowed = _a.sent();
                    // 如果外部拒绝，不删除标签
                    if (!allowed) {
                        return [2 /*return*/];
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    // 如果请求失败，不删除标签
                    return [2 /*return*/];
                case 4:
                    // 更新标签列表
                    setTagList(updatedTags);
                    // 触发变化回调（仅在确认后触发）
                    if (onChange) {
                        onChange(updatedTags);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    // 处理输入框回车事件
    var handleInputPressEnter = function () {
        handleAddTag();
    };
    // 拖拽排序：移动标签到目标位置
    var moveTag = function (fromKey, toKey) {
        if (fromKey === toKey)
            return;
        var fromIndex = tagList.findIndex(function (t) { return (t.id || t.label) === fromKey; });
        var toIndex = tagList.findIndex(function (t) { return (t.id || t.label) === toKey; });
        if (fromIndex < 0 || toIndex < 0)
            return;
        var next = __spreadArray([], tagList, true);
        var moved = next.splice(fromIndex, 1)[0];
        next.splice(toIndex, 0, moved);
        setTagList(next);
        if (onChange)
            onChange(next);
    };
    return (_jsxs("div", __assign({ className: className, style: __assign({ width: "100%", height: "100%", display: "flex", flexDirection: "column", minWidth: 0, overflow: "hidden" }, style) }, { children: [!hideInput && (_jsx("div", __assign({ style: { marginBottom: 4, flexShrink: 0 } }, { children: _jsx(Input, { value: inputValue, onChange: function (e) { return setInputValue(e.target.value); }, onPressEnter: handleInputPressEnter, placeholder: placeholder, disabled: disabled, allowClear: true, style: { fontSize: 14 } }) }))), _jsx("div", __assign({ style: {
                    flex: 1,
                    overflowY: "auto",
                    overflowX: "hidden",
                    minHeight: 0,
                    width: "100%",
                    paddingTop: 16,
                    paddingBottom: 16,
                    boxSizing: "border-box",
                } }, { children: _jsx("div", __assign({ style: {
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 8,
                        alignContent: "flex-start",
                        alignItems: "flex-start",
                        width: "100%",
                        minHeight: "min-content",
                        boxSizing: "border-box",
                    } }, { children: tagList.length === 0 ? (_jsx("div", __assign({ style: {
                            width: "100%",
                            textAlign: "center",
                            color: "#999",
                            padding: "20px 0",
                        } }, { children: "\u6682\u65E0\u6807\u7B7E" }))) : (tagList.map(function (tag) {
                        // 获取标签的唯一 key
                        var tagKey = tag.id || tag.label;
                        // 判断当前标签是否被悬停
                        var isHovered = hoveredTagKey === tagKey;
                        var canDrag = draggable && !disabled;
                        return (_jsx(Tag, __assign({ color: tag.color, closable: !disabled, onClose: function () { return handleRemoveTag(tag); }, draggable: canDrag, onDragStart: function () { return setDraggingKey(tagKey); }, onDragEnd: function () { return setDraggingKey(null); }, onDragOver: function (e) {
                                if (!canDrag)
                                    return;
                                e.preventDefault();
                            }, onDrop: function (e) {
                                if (!canDrag)
                                    return;
                                e.preventDefault();
                                if (draggingKey == null)
                                    return;
                                moveTag(draggingKey, tagKey);
                            }, closeIcon: _jsx(CloseOutlined, { style: {
                                    verticalAlign: "middle",
                                    marginTop: "-2px",
                                    marginRight: "-3px",
                                } }), style: {
                                fontSize: 12,
                                margin: 0,
                                boxShadow: isHovered
                                    ? "0 2px 8px rgba(0, 0, 0, 0.3)"
                                    : "none",
                                transition: "box-shadow 0.2s ease",
                                cursor: canDrag ? "move" : "default",
                                opacity: draggingKey === tagKey ? 0.7 : 1,
                            }, onMouseEnter: function () { return setHoveredTagKey(tagKey); }, onMouseLeave: function () { return setHoveredTagKey(null); } }, { children: tag.label }), tagKey));
                    })) })) }))] })));
};
export default CompsTags;
